module.exports = __webpack_public_path__ + "img/ico_arrow_up_white.9bab0400.svg";